import { render } from "./popover.vue?vue&type=template&id=19314e9d"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__